<!--
 * @Description: 机构审核操作组件
 * @Author: wanqian
 * @Date: 2022-05-25 15:31:35
-->
<template>
  <!-- 审核状态：0-未审核 1-审核通过 2-审核拒绝 3-撤回	 -->
  <div class="review-actions-body">
    <el-row justify="space-between" align="center">
      <el-col :span="8">
        <span>
					提交人： {{ review.submiterText == null ? "- -" : review.submiterText }}
				</span>
      </el-col>
      <el-col :span="8">
        <span class="text">
					账户名： {{ review.username }}
				</span>
      </el-col>
      <el-col :span="8" style="text-align: right">
        <span v-if="review.status != 1" class="status-button"
          style="background: #3e7ef6; cursor: pointer" @click="handleReviewPass">
          <img style="width: 18px; height: 20px; vertical-align: middle"
            src="@/assets/reviewmng/icon-attendant-review-list-pass.png" alt="" />
          <span style="margin-left: 2px">
						通过
		  		</span>
        </span>
      </el-col>
    </el-row>
    <el-row justify="space-between" align="center" style="margin-top: 20px">
      <el-col :span="8">
        <span class="text">
					手机号： {{ review.moblie }}
				</span>
      </el-col>
      <el-col :span="8">
        <span class="text">
					提交时间： {{ review.submitTime }}
				</span>
      </el-col>
      <el-col :span="8" style="text-align: right">
        <span v-if="review.status != 1 && review.status != 2" class="status-button"
          style="background: #e04a52; cursor: pointer" @click="handleReviewReject">
          <img style="width: 18px; height: 20px; vertical-align: middle"
            src="@/assets/reviewmng/icon-attendant-review-list-nopass.png" alt="" />
          <span style="margin-left: 2px">
						驳回
					</span>
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ["review"],

  methods: {
    handleReviewPass() {
      this.$emit("handle-review", "approve", this.review.version);
    },

    handleReviewReject() {
      this.$emit("handle-review", "reject", this.review.version);
    }
  }
};
</script>

<style scoped>
.review-actions-body {
  padding: 15px 25px;
  background-color: #f7f9fe;
  line-height: 31px;
}

.text {
  font-size: 15px;
  color: #525254;
  line-height: 21px;
}

.status-button {
  display: inline-block;
  width: 98px;
  height: 31px;
  border-radius: 2px;
  text-align: center;
  line-height: 31px;
  font-size: 15px;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/review/components/InstReviewDetails/InstReviewActionsDetails.vue